module.exports = __webpack_public_path__ + "img/stock6.fe1d95a2.png";